<template>
  <div>
    <div class="row">
      <div class="col-md-3" v-for="card in cards" :key="card.title">
        <div class="grid">
          <div class="grid-body">
            <h4 :class="'text-bold text-' + card.color">{{ card.label }}</h4>
            <h2 class="text-bold">{{ ezy.comma(card.total, 0) }}</h2>
            <span v-if="card.finished_shirt"
              >Finished Today : {{ card.finished_shirt }}</span
            >
            <span v-else>&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statusIdToStatus from "@/pages/Tools/statusIdToStatus";
export default {
  data() {
    return {
      cards: [],
      allStatuses: [],
    };
  },
  async mounted() {
    this.allStatuses = await statusIdToStatus.getStatuses();
    this.allStatuses = this.allStatuses.sort(function (a, b) {
      return a.sorter - b.sorter;
    });
    this.getData();
  },
  methods: {
    async getData() {
      /**
       * filter unwanted dashboard from all statuses
       * not to show in dashboard
       */
      let statuses = this.allStatuses.filter((status) => {
        return (
          status.id != shirtOrderStatus.SENT_TO_GERMANY &&
          status.id != "repair" &&
          status.id != shirtOrderStatus.PATTERN_PRINTED &&
          status.id != shirtOrderStatus.WAITING_FOR_BUTTON &&
          status.id != shirtOrderStatus.WAITING_FOR_BUTTON_2 &&
          status.id != shirtOrderStatus.BUTTON_HOLE &&
          status.id != shirtOrderStatus.WAITING_FOR_EMB
        );
      });

      try {
        let res = await axios.post("shirt_orders/dashboard", { statuses });
        let cards = res.data;

        // sum 2 qc station
        res.data.forEach((card) => {
          if (card.id == shirtOrderStatus.QC_2) {
            let index = cards.findIndex((x) => x.id == shirtOrderStatus.QC_1);
            cards[index].total += card.total;
            cards[index].label = "QC";
            let index2 = cards.findIndex((x) => x.id == shirtOrderStatus.QC_2);
            cards.splice(index2, 1);
          }
        });
        this.cards = cards;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
  },
};
</script>

<style>
</style>
